import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

import Image from '@/app/components/Image';

export interface LandingPageMembershipTabContentFeaturedImageProps {
  readonly backgroundImage: {
    alt: MessageKey;
    src: string;
  };
  readonly Icon: SVGIconComponent;
}

const LandingPageMembershipTabContentFeaturedImage = ({
  backgroundImage,
  Icon,
}: LandingPageMembershipTabContentFeaturedImageProps): JSX.Element => {
  return (
    <div
      className="relative hidden h-[418px] w-[300px] overflow-hidden rounded-lg lg:block"
      data-cy="landing-page-membership-tab-featured-img"
    >
      <Image
        className="absolute left-0 top-0 size-full"
        height={420}
        localizedAlt={backgroundImage.alt}
        src={backgroundImage.src}
        width={300}
      />
      <div className="absolute left-0 top-0 flex size-full items-center justify-center text-white">
        <Icon height="62" width="62" />
      </div>
    </div>
  );
};

export default LandingPageMembershipTabContentFeaturedImage;
